import jsCookie from 'js-cookie';
import { auth } from '../firebase';

class AuthService {
  static getAuthCookie(){
    if(!!jsCookie.get('access_token')) {
      return jsCookie.get('access_token')
    } else {
      return false
    }
  }
  static setAuthCookie(token){
    return jsCookie.set('access_token', token);
  }

  static isLoggedIn() {
    return !!jsCookie.get('access_token');
  }

  static logOut(e = false) {
    if(e) {
      e.preventDefault();
    }
    auth.doSignOut();
    jsCookie.remove('access_token');
  }
}

export default AuthService;




// WEBPACK FOOTER //
// ./src/services/auth.js